import { render, staticRenderFns } from "./trechos.vue?vue&type=template&id=347d91d7"
import script from "./trechos.vue?vue&type=script&lang=js"
export * from "./trechos.vue?vue&type=script&lang=js"
import style0 from "./trechos.vue?vue&type=style&index=0&id=347d91d7&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports